import { render, staticRenderFns } from "./LargePdfImageUiSetting.vue?vue&type=template&id=4b8b6c1e"
import script from "./LargePdfImageUiSetting.vue?vue&type=script&lang=ts"
export * from "./LargePdfImageUiSetting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports